import { render, staticRenderFns } from "./asiakirjat-upload.vue?vue&type=template&id=47bee325&scoped=true&"
import script from "./asiakirjat-upload.vue?vue&type=script&lang=ts&"
export * from "./asiakirjat-upload.vue?vue&type=script&lang=ts&"
import style0 from "./asiakirjat-upload.vue?vue&type=style&index=0&id=47bee325&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bee325",
  null
  
)

export default component.exports